import { render, staticRenderFns } from "./Ag-remove.vue?vue&type=template&id=4cd4c227&scoped=true&"
import script from "./Ag-remove.vue?vue&type=script&lang=js&"
export * from "./Ag-remove.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "4cd4c227",
  null
  
)

export default component.exports